import React from 'react';
import {sortableContainer, sortableElement, sortableHandle,} from 'react-sortable-hoc';
import ConfirmModalPOS from './Component/ConfirmModalPOS';

let hold_mouse_time = 0;
let setTime = null;
let longPressTime = 10;

export const DragHandle = sortableHandle(({children}) => (<>{children}</>));

export const SortableItem = sortableElement(({children}) => (<>{children}</>));

export const SortableContainer = sortableContainer(({children}) => (<>{children}</>));

export const Helper = {
	setAmount(amount) {
		amount = amount.replace(/,/g, '');
		if (isNaN(amount) || amount === '' || parseFloat(amount) < 0) {
			amount = '0';
		}
		let count = (amount.match(/\./g) || []).length;
		if (count === 2) {
			amount = amount.replace('..', '.');
		}
		if (count === 0) {
			amount = parseFloat(amount);
		}
		return amount
	},
	messageTopPOS(options) {
		// Remove old MessageTop
		var $MessageTop = window.$('.MessageTop');
		if ($MessageTop.length) {
			$MessageTop.each(function () {
				var $e = window.$(this);
				$e.addClass('fadeOut');
				setTimeout(function () {
					$e.remove();
				}, 3000);
			});
		}

		if (!options.type) {
			options.type = 'positive';
		}

		if (options.html) {
			options.content = options.html;
		} else {
			options.content = '<div class="ui compact ' + options.type + ' message"><h3>' + options.message + '</h3></div>';
		}

		if (!options.delay) {
			options.delay = 8000;
			if (options.type === 'negative') {
				options.delay = 15000;
			}
		}

		var $e = window.$(window.Handlebars.compile('<div class="MessageTop flex row center align animated massive-message" style="{{style}}">\n    {{{content}}}\n</div>')(options));
		// var $Root;
		// if (options.node) {
		// 	$Root = options.node;
		// } else {
		// 	$Root = $('#Root');
		// }
		window.$('body').append($e);

		$e.css({
			fontWeight: 'bold',
			cursor: 'pointer',
			marginLeft: (window.$('body').width() / 2) - ($e.width() / 2)
		});
		$e.addClass('bounceInDown');
		setTimeout(function () {
			$e.addClass('fadeOut');
			setTimeout(function () {
				$e.remove();
			}, 1000);
		}, options.delay);
		$e.off().on('click', () => {
			$e.addClass('fadeOut');
			setTimeout(function () {
				$e.remove();
			}, 1000);
		})
	},
	posConfirmModal(options) {
		window.Global.reactToDom(window.$('body'),
			<ConfirmModalPOS {...options}/>
		);
	},
	confirmPOS(options) {
		options.approve_text2 = 'ใช่';
		options.cancel_text2 = 'ไม่ใช่';
		if (options.approve_text) options.approve_text2 = options.approve_text;
		if (options.cancel_text) options.cancel_text2 = options.cancel_text;
		if (!options.modal_class) options.modal_class = 'ui modal pos-modal-confirm';
		if (!options['approve_button_class']) options['approve_button_class'] = 'green';
		if (typeof options['closable'] === 'undefined') options['closable'] = true;
		if (typeof options['autofocus'] === 'undefined') options['autofocus'] = false;
		if (typeof options['observeChanges'] === 'undefined') options['observeChanges'] = true;
		var $modal = window.$(window.Handlebars.compile('<div class="{{modal_class}}">\n    <i class="close icon"></i>\n    <div class="header">\n        {{title}}\n    </div>\n    <div class="content">\n        {{{content}}}\n    </div>\n    <div class="actions">\n        <div class="flex row">\n            {{{left_button}}}\n            <div class="right floated">\n                <div class="ui deny massive button">{{cancel_text2}}</div><div class="ui approve right button massive {{approve_button_class}}">{{approve_text2}}</div>\n            </div>\n        </div>\n    </div>\n</div>')(options));
		$modal.modal({
			closable: options['closable'],
			autofocus: options['autofocus'],
			observeChanges: options['observeChanges'],
			onShow: function () {
				if (options.onShowToSetupForm) {
					return options.onShowToSetupForm($modal);
				}
				if (options.onShow) {
					return options.onShow($modal);
				}
			},
			onApprove: function ($element) {
				if (options.onShowToSetupForm) {
					$modal.find('form').trigger('submit');
					return false;
				}
				if (options.onApprove) {
					return options.onApprove($modal, $element);
				}
			},
			onDeny: function ($element) {
				if (options.onDeny) {
					return options.onDeny($modal, $element);
				}
			},
			onHide: function ($element) {
				if (options.onHide) {
					return options.onHide($modal, $element);
				}
				setTimeout(function () {
					$element.remove();
				}, 2000);
			}
		}).modal('show');
		$modal.find('.close').remove();
		return {
			$modal: $modal
		};
	},
	setDecimal: (text) => {
		let value = text + '';
		let sprit = [];
		if (text.length > 0) {
			sprit = text.split('');
		}
		if (text.length === 1 && text === '.') {
			value = '0.';
		}
		let count_dot = sprit.filter((item) => {
			return item === '.'
		}).length;
		if (count_dot > 1) {
			let count = 0;
			let new_array = [];
			sprit.forEach((item) => {
				if ((count === 0 && item === ".") || item !== '.') {
					new_array.push(item);
				}
				if (item === ".") {
					count++;
				}
			})
			value = new_array.toString()
			value = value.replace(/,/g, '');
		}
		return value;
	},
	getQueryStringParams: (query) => {
		return query
			? (/^[?#]/.test(query) ? query.slice(1) : query)
				.split('&')
				.reduce((params, param) => {
						let [key, value] = param.split('=');
						params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
						return params;
					}, {}
				)
			: {}
	},
	searchToObject: (search) => {
		var pairs = search.substring(1).split("&"),
			obj = {},
			pair,
			i;

		for (i in pairs) {
			if (pairs[i] === "") continue;

			pair = pairs[i].split("=");
			obj[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
		}

		return obj;
	},
	isMethodMoneyIn: (method) => {
		return method === 'pay_in' || method === 'deposit_in' || method === 'refund_in';
	},
	getRatioUnit(product, ratio) {
		let unit = {};
		product.sell_price.forEach((sell_price) => {
			if (parseFloat(ratio) === parseFloat(sell_price.ratio)) {
				unit = sell_price;
				return true;
			}
		});
		return unit;
	},
	getRatioUnitByOrder(_sell_price, options) {
		let unit = {};
		let min = _sell_price[0],
			max = _sell_price[0];
		_sell_price.forEach((sell_price) => {
			min = (sell_price.ratio < min.ratio) ? sell_price : min;
			max = (sell_price.ratio > max.ratio) ? sell_price : max;
		});
		if (options && options.return_sell_price === 'min') {
			unit = min;
		}
		if (options && options.return_sell_price === 'max') {
			unit = max;
		}
		return unit;
	},
	calculateSummary(data, items, options) {

		if (!options) options = {};
		let is_has_data = !!data;

		let tax_type;
		let tax_all = 0;
		let discount_all = 0;
		let discount_all_type = '%';

		tax_type = data['tax_type'];
		tax_all = data['tax'] ? data['tax'] : 0;
		discount_all = data['discount'] ? data['discount'] : 0;
		discount_all_type = data['discount_type'] ? data['discount_type'] : '%';

		if (!tax_type) tax_type = 'none';

		tax_all = parseFloat(tax_all);
		if (isNaN(tax_all)) tax_all = 0;

		discount_all = parseFloat(discount_all);
		if (isNaN(discount_all)) discount_all = 0;

		let summary = {
			tax_type: tax_type,
			tax: tax_all,
			discount: discount_all,
			discount_type: discount_all_type,
			discount_amount: 0,
			total_price_before_discount: 0, // รวมเป็นเงิน
			total_price_deposit: 0, // ยอดหักจากเงินมัดจำ
			total_price: 0, // รวมเป็นเงิน (รวมมูลค่าสินค้าหลังหักส่วนลดรวมและมัดจำ จะนำยอดตรงนี้ไปคิด VAT)
			total_price_include_vat: 0, // จำนวนเงินรวมทั้งสิ้น (เฉพาะรายการที่มี VAT)
			total_price_exclude_vat: 0, // ราคาไม่รวมภาษีมูลค่าเพิ่ม (เฉพาะรายการที่มี VAT)
			total_price_none_vat: 0, // ยอดไม่มีภาษี
			total_price_zero_vat: 0, // ยอดมูลค่าภาษีศูนย์
			total_price_except_vat: 0, // ยอดมูลค่ายกเว้นภาษี
			total_price_withholding_tax: 0, // หักภาษี ณ ที่จ่าย
			total_tax_price: 0, // จำนวนภาษีมูลค่าเพิ่ม
			total_net_price_without_withholding_tax: 0, // จำนวนเงินรวมทั้งสิ้น
			total_net_price: 0, // ยอดชำระ
			total_quantity: 0
		};

		let _summary_each_tax = {};

		let calculate = function (item) {
			let quantity = parseFloat(item.quantity);
			if (isNaN(quantity)) quantity = 0;
			let ratio = parseFloat(item.ratio);
			if (isNaN(ratio)) ratio = 1;
			let price = parseFloat(item.price);
			if (isNaN(price)) price = 0;
			let tax = parseFloat(item.tax);
			if (isNaN(tax)) tax = 0;
			let discount = parseFloat(item.discount);
			if (isNaN(discount)) discount = 0;

			// สำหรับเงินเดือน
			if (item['payment_item_salary_type']) {
				if (item['payment_item_salary_type'] === 'deduction') {
					price = -price;
				}
			}

			summary.total_quantity += quantity;

			let item_price = (quantity / ratio) * price;
			if (discount && item_price > 0) {
				let discount_amount = discount;
				if (!item['discount_type']) item['discount_type'] = '%';
				if (item['discount_type'] === '%') {
					discount_amount = (item_price * (discount * 0.01));
				}
				item_price = item_price - discount_amount;
			}

			item_price = item_price.round(2);

			summary.total_price_before_discount += item_price;

			// แยกภาษีแต่ละประเภท
			let key = item.tax_type + '_' + tax;
			if (typeof _summary_each_tax[key] === 'undefined') {
				_summary_each_tax[key] = {
					tax: tax,
					tax_type: item.tax_type,
					total_price: 0
				};
			}
			_summary_each_tax[key]['total_price'] += item_price;
		};

		if (!is_has_data) {
			items = window.object['item'];
		}
		items.map((value) => {
			calculate(value);
			return false;
		});

		summary.total_price = summary.total_price_before_discount;

		// if (Object.keys(_summary_each_tax).length > 1) {
		//  if ($parent) {
		//   $parent.find('input[name="discount"]').val(0);
		//  }
		//  discount_all = 0;
		// }

		// ถ้าส่วนลดรวมต้องตีบาทเป็น % ก่อน
		let discount_all_percent_from_bath = 0;
		if (discount_all
			&& discount_all_type === '฿'
		) {
			if (summary.total_price_before_discount === 0) {
				discount_all_percent_from_bath = 0;
			} else {
				discount_all_percent_from_bath = (discount_all / summary.total_price_before_discount) * 100;
			}
		}

// ส่วนลดรวม
		if (discount_all) {
			Object.keys(_summary_each_tax).forEach(function (key) {
				let discount_amount = discount_all;
				if (discount_all_type === '%') {
					discount_amount = (_summary_each_tax[key]['total_price'] * (discount_all * 0.01));
				} else {
					discount_amount = (_summary_each_tax[key]['total_price'] * (discount_all_percent_from_bath * 0.01));
				}

				_summary_each_tax[key]['total_price'] -= discount_amount;

				summary.discount_amount += discount_amount;
				summary.total_price -= discount_amount;
			});
		}
		summary.discount_amount = summary.discount_amount.round(2);
		summary.total_price = summary.total_price.round(2);
		// END ส่วนลดรวม

		// หักเงินมัดจำ
		Object.keys(_summary_each_tax).forEach(function (key) {
			Object.keys(data.payment).forEach(function (i) {
				if (data.payment[i].payment_by !== 'deposit') {
					return;
				}
				if (!data.payment[i].payment_deposit) {
					// ยังไม่ได้เลือกว่าเป็นมัดจำใบไหน
					return;
				}
				if (parseFloat(_summary_each_tax[key].tax) === parseFloat(data.payment[i].payment_deposit.payment_item[0].tax)) {
					summary.total_price_deposit += parseFloat(data.payment[i].price);
					// ลดมูลค่ากลุ่มรายการที่มี % ภาษีตรงกัน
					_summary_each_tax[key]['total_price'] -= parseFloat(data.payment[i].price);
				}
			});
		});
		summary.total_price -= summary.total_price_deposit;
		summary.total_price = summary.total_price.round(2);
		// END หักเงินมัดจำ
		Object.keys(_summary_each_tax).forEach(function (key) {
			let summary_each_tax = _summary_each_tax[key];

			// console.log(key, summary_each_tax);
			let tax_price = 0;
			if (tax_type === 'include_vat') {
				let item_price_exclude_vat = summary_each_tax.total_price * (100 / (100 + summary_each_tax.tax));
				item_price_exclude_vat = item_price_exclude_vat.round(2);
				tax_price = summary_each_tax.total_price - item_price_exclude_vat;
				if (summary_each_tax.tax_type === 'include_vat'
					|| summary_each_tax.tax_type === 'exclude_vat'
				) {
					if (summary_each_tax.tax === 0) {
						summary.total_price_zero_vat += item_price_exclude_vat;
					} else {
						summary.total_price_exclude_vat += item_price_exclude_vat;
						summary.total_price_include_vat += summary_each_tax.total_price;
					}
				}
				if (summary_each_tax.tax_type === 'except_vat') {
					summary.total_price_except_vat += item_price_exclude_vat;
				}
				summary.total_net_price += summary_each_tax.total_price;
			} else if (tax_type === 'exclude_vat') {
				tax_price = (summary_each_tax.total_price * (summary_each_tax.tax / 100)).round(2);
				if (summary_each_tax.tax_type === 'include_vat'
					|| summary_each_tax.tax_type === 'exclude_vat'
				) {
					if (summary_each_tax.tax === 0) {
						summary.total_price_zero_vat += summary_each_tax.total_price;
					} else {
						summary.total_price_exclude_vat += summary_each_tax.total_price;
						summary.total_price_include_vat += summary_each_tax.total_price + tax_price;
					}
				}
				if (summary_each_tax.tax_type === 'except_vat') {
					summary.total_price_except_vat += summary_each_tax.total_price;
				}
				summary.total_net_price += summary_each_tax.total_price + tax_price;
			} else {
				summary.total_price_none_vat += summary_each_tax.total_price;
				summary.total_net_price = summary_each_tax.total_price;
			}
			summary.total_tax_price += tax_price;
		});

		// หัก ณ ที่จ่าย
		summary.total_price_withholding_tax = parseFloat(data.total_price_withholding_tax);
		// END หัก ณ ที่จ่าย

		summary.total_net_price -= summary.total_price_withholding_tax;

		summary.total_net_price_without_withholding_tax = summary.total_net_price + summary.total_price_withholding_tax;

		summary['total_price'] = summary['total_price'].round(2);
		summary['total_price_include_vat'] = summary['total_price_include_vat'].round(2);
		summary['total_price_exclude_vat'] = summary['total_price_exclude_vat'].round(2);
		summary['total_price_none_vat'] = summary['total_price_none_vat'].round(2);
		summary['total_price_zero_vat'] = summary['total_price_zero_vat'].round(2);
		summary['total_price_except_vat'] = summary['total_price_except_vat'].round(2);
		summary['total_tax_price'] = summary['total_tax_price'].round(2);
		summary['total_net_price_without_withholding_tax'] = summary['total_net_price_without_withholding_tax'].round(2);
		summary['total_net_price'] = summary['total_net_price'].round(2);
		// มัดจำต้องหาว่ามูลค่าสูงสุดที่เป็น % ภาษีเดียวกัน เพื่อหาราคามัดจำสูงสุดที่ตัดได้
		summary.summary_each_tax = _summary_each_tax;

		summary.discount_amount2 = summary.discount_amount.format(2, 3, {pretty: false});
		summary.total_price_before_discount2 = summary.total_price_before_discount.format(2, 3, {pretty: false});
		summary.total_price_deposit2 = summary.total_price_deposit.format(2, 3, {pretty: false});
		summary.total_price2 = summary.total_price.format(2, 3, {pretty: false});
		summary.total_price_include_vat2 = summary.total_price_include_vat.format(2, 3, {pretty: false});
		summary.total_price_exclude_vat2 = summary.total_price_exclude_vat.format(2, 3, {pretty: false});
		summary.total_price_none_vat2 = summary.total_price_none_vat.format(2, 3, {pretty: false});
		summary.total_price_zero_vat2 = summary.total_price_zero_vat.format(2, 3, {pretty: false});
		summary.total_price_except_vat2 = summary.total_price_except_vat.format(2, 3, {pretty: false});
		summary.total_price_withholding_tax2 = summary.total_price_withholding_tax.format(2, 3, {pretty: false});
		summary.total_tax_price2 = summary.total_tax_price.format(2, 3, {pretty: false});
		summary.total_net_price_without_withholding_tax2 = summary.total_net_price_without_withholding_tax.format(2, 3, {pretty: false});
		summary.total_net_price2 = summary.total_net_price.format(2, 3, {pretty: false});
		summary.total_quantity2 = summary.total_quantity.format(2, 3, {pretty: false});
		// console.log(_summary_each_tax);
		// console.log(summary);
		// console.log(data);
		return summary;


	},
	CalculateItemPrice(item, $options) {
		let quantity = parseFloat(item['quantity']);

		let ratio = 1;
		if (item['ratio']) {
			ratio = parseFloat(item['ratio']);
		}

		let price = parseFloat(item['price']);

		let discount = 0;
		if (item['discount']) {
			discount = parseFloat(item['discount']);
		}

		if (!item['tax']) item['tax'] = 0;
		let tax = parseFloat(item['tax']);

		let discount_amount = 0;
		// console.log(price);
		// console.log(discount);
		let item_price = (quantity / ratio) * price;
		if (discount) {
			discount_amount = discount;
			if (!item['discount_type']) item['discount_type'] = '%';
			if (item['discount_type'] === '%') {
				discount_amount = (item_price * (discount * 0.01));
			}
			item_price = item_price - discount_amount;
		}
		item_price = item_price.round(2);

		let total_price_zero_vat = 0;
		let total_price_none_vat = 0;
		let total_price_exclude_vat = 0;
		let total_price_include_vat = 0;
		let total_price_except_vat = 0;
		let total_net_price = 0;

		let tax_price = 0;

		if ($options['tax_type'] === 'include_vat') {
			let item_price_exclude_vat = item_price * (100 / (100 + tax));
			item_price_exclude_vat = item_price_exclude_vat.round(2);
			tax_price = item_price - item_price_exclude_vat;
			if (item['tax_type'] === 'include_vat'
				|| item['tax_type'] === 'exclude_vat'
			) {
				if (tax === 0) {
					total_price_zero_vat += item_price_exclude_vat;
				} else {
					total_price_exclude_vat += item_price_exclude_vat;
					total_price_include_vat += item_price;
				}
			}
			if (item['tax_type'] === 'except_vat') {
				total_price_except_vat += item_price_exclude_vat;
			}
			total_net_price += item_price;
		} else if ($options['tax_type'] === 'exclude_vat') {
			tax_price = (item_price * (tax / 100)).round(2);
			if (item['tax_type'] === 'include_vat'
				|| item['tax_type'] === 'exclude_vat'
			) {
				if (tax === 0) {
					total_price_zero_vat += item_price;
				} else {
					total_price_exclude_vat += item_price;
					total_price_include_vat += item_price + tax_price;
				}
			}
			if (item['tax_type'] === 'except_vat') {
				total_price_except_vat += item_price;
			}
			total_net_price += item_price + tax_price;
		} else {
			total_price_none_vat = item_price;
			total_net_price = item_price;
		}

		total_price_include_vat = total_price_include_vat.round(2);
		total_price_exclude_vat = total_price_exclude_vat.round(2);
		total_price_none_vat = total_price_none_vat.round(2);
		total_price_zero_vat = total_price_zero_vat.round(2);
		total_price_except_vat = total_price_except_vat.round(2);
		tax_price = tax_price.round(2);
		total_net_price = total_net_price.round(2);

		return {
			'tax_type': item['tax_type'],
			'tax': tax,
			'discount': discount,
			'discount_type': item['discount_type'],
			'discount_amount': discount_amount,
			'total_price': item_price,
			'total_price_include_vat': total_price_include_vat,
			'total_price_exclude_vat': total_price_exclude_vat,
			'total_price_none_vat': total_price_none_vat,
			'total_price_zero_vat': total_price_zero_vat,
			'total_price_except_vat': total_price_except_vat,
			'total_price_withholding_tax': 0,
			'total_tax_price': tax_price,
			'total_net_price': total_net_price,
			'quantity': quantity,

			'tax_price': tax_price,
			'item_price': item_price
		};
	},
	defaultPOSPayment(payments, items, login_user_id, pos) {
		return [
			{
				payment_by: 'cash',
				price: this.calculateSummary(payments, items).total_net_price,
				payment_by_cash_pos: {
					pos_id: pos.id,
					pos_shift_id: pos.last_pos_shift.id,
					receive_amount: 0,
					change_amount: 0,
					banknote_1000: 0,
					banknote_500: 0,
					banknote_100: 0,
					banknote_50: 0,
					banknote_20: 0,
					coin_10: 0,
					coin_5: 0,
					coin_2: 0,
					coin_1: 0,
					coin_0_5: 0,
					coin_0_25: 0,
				},
				cash_by_user_id: login_user_id,
			}
		];
	},
	longPressStart(options) {
		hold_mouse_time = 0;
		let delay = options.delay || 150
		setTime = setInterval(() => {
			hold_mouse_time++;
			if (hold_mouse_time === longPressTime) {
				if (options.onLongPress) {
					options.onLongPress();
				}
				clearInterval(setTime);
			}
		}, delay);
	},
	longPressEnd(options) {
		if (hold_mouse_time < longPressTime) {
			if (options.onPress) {
				options.onPress();
			}
		}
		clearInterval(setTime);
	},
	printerQueue(payment, options) {
		// console.log(payment);
		let pos = localStorage.getItem("pos") && localStorage.getItem("pos") !== '' ? JSON.parse(localStorage.getItem("pos")) : false;
		window.Global.ajax({
			url: process.env.REACT_APP_DOMAIN + '/api/printer_queue',
			method: 'POST',
			data: {
				printer_id: pos.pos_default_payment.printer_id,
				type: 'payment',
				reference_id: payment.id,
				status: 'complete',
			},
			done: (responseJson) => {
				// console.log(responseJson);
				if (responseJson.error) {
					if (options.onError) {
						options.onError(responseJson);
					}
				}
				if (responseJson.success) {
					if (options.onSuccess) {
						options.onSuccess(responseJson);
					}
					window.Global.ajax({
						url: 'http://localhost/print-service.php',
						method: 'POST',
						data: responseJson.printer_queue.print_command,
						done: (responseJson2) => {
							console.log(responseJson2);
							if (responseJson2.success && options.onPrintFinish) {
								options.onPrintFinish(responseJson);
							}
						}
					});

					// Helper.Print({
					// 	print_command: responseJson.printer_queue.print_command.print_command,
					// 	print_loop_delay: responseJson.printer_queue.print_command.print_loop_delay,
					// 	finish: () => {
					// 		if (options.onPrintFinish) {
					// 			options.onPrintFinish(responseJson);
					// 		}
					// 		return false;
					// 	}
					// });
				}
			}
		})
	},
	getProductStock: (product, stock_id) => {
		let stock1 = false;
		window.$.each(product.product_stock, function (key, v) {
			if (parseInt(v.stock_id) === parseInt(stock_id)) {
				stock1 = v;
				return true;
			}
		});
		if (stock1 === false) {
			stock1 = {
				on_hand: 0,
				incoming: 0,
				available: 0,
				committed: 0,
			}
		}
		return stock1;
	},
	nodeMaxHeight: (ref, options) => {
		let height = window.$(ref).height();
		if (height > options.maxHeight) {
			window.$(ref).css({
				height: options.maxHeight,
				overflowY: 'hidden'
			});
			let $e = window.$('<div style="position: absolute;bottom: 1rem;left: 0;width: 100%;" class="flex row center-xs middle-xs">\n\t<button type="button" class="ui small button basic green circular">ดูเพิ่มเติม</button>\n</div>')
			window.$(ref).append($e);
			$e.find('button').on('click', function () {
				window.$(this).parent().remove();
				window.$(ref).css({
					height: 'initial',
					overflowY: 'auto'
				});
			});
		}
	}
}

export const ProductsetupQuantityAndRatio = {
	setupQuantityAndRatio: (ref, product, options) => {
		let $e = window.GlobalFunc.setupQuantityAndRatio(window.$(ref), {
			product: product,
			quantity: options.quantity || product.default_item_sell.quantity,
			input_quantity: options.quantity_input_name || 'item[][quantity]',
			ratio: options.ratio || product.default_item_sell.ratio,
			input_ratio: options.ratio_input_name || 'item[][ratio]',
			quantityReadOnly: false,
			onChange: (item) => {
				if (options.onChangeQuantityAndRatio) {
					options.onChangeQuantityAndRatio(item)
				}
			}
		});
		$e.attr('class', '');
		window.GlobalFunc.setQuantityUnitName(window.$(ref), {
			$quantity: $e.find('input[name="item[][quantity]"]'),
			quantity: 1,
			ratio: product.ratio,
			$unit_name_dropdown: $e.find('.Item_selectUnitName'),
			product: product,
		})
	}
}
